import { InventoryManagerFormValues } from "../components/forms/InventoryManagerForm/InventoryManagerForm.types";
import { InventoryManagerListItem } from "../inventory.types";

export const getInitialManagerFormValues = (
  editableManager: InventoryManagerListItem | null
): InventoryManagerFormValues => ({
  id: editableManager?.id,
  firstname: editableManager?.firstname ?? "",
  lastname: editableManager?.lastname ?? "",
  phoneNumber: editableManager?.phoneNumber ?? "",
  image: editableManager?.image ?? null,
  password: "",
  repeatPassword: ""
});
